<script lang="ts">
  import type { Graphic, Maybe } from "../types";

  type Props = {
    alt: Maybe<string>;
    src: Maybe<Graphic>;
  };

  const { alt, src }: Props = $props();
</script>

<h1 class="Header">
  {#if src}
    <img class="Hero" {src} width="240" height="240" {alt} />
  {:else}
    <span class="Hero">{alt}</span>
  {/if}
</h1>

<style>
  .Header {
    align-items: center;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), transparent 30px),
      var(--theme-color, black);
    display: flex;
    justify-content: center;
    padding: 0 var(--outer-padding);
  }
  .Hero {
    display: block;
    max-height: var(--standard-hero-height);
    min-height: 50px;
    max-width: 100%;
    object-fit: contain;
  }
</style>
